<template>
  <v-layout row wrap pa-3>
    <v-flex xs12 md9 wrap>
      <v-layout column main-section>
        <v-flex pt-3>
          <v-card-title>
            <v-icon>mdi-coin</v-icon>
            <h4 class="headline halfwhite-text ml-2">Manage Funds</h4>
            <!-- <h3 class="halfwhite-text">
              {{ $store.getters.getHeadingForBalanceBlock }}
            </h3>
            <h3 class="section-title halfwhite-text text-uppercase">
              Manage Funds
            </h3> -->
          </v-card-title>
          <v-flex ml-3 mt-3 v-if="!$store.getters.isCurrentOrgSet">
            <v-card color="white" class="rounded">
              <v-card-text>
                <div>
                  There is no active org available in your user profile, please
                  create a new org or switch to an existing org.
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex ml-3 mt-3 v-else>
            <v-flex mb-2>
              <v-card color="white" class="rounded">
                <v-card-title class="mb-0">
                  <h4 class="subheading">Add Fund</h4>
                </v-card-title>
                <v-card-text>
                  <!--Display error if current org not set or user does not have SuperAdmin Role -->
                  <v-flex>
                    <v-alert
                      v-if="!$store.getters.isSuperAdmin"
                      :value="true"
                      type="error"
                      class="mb-3"
                      >Sorry! You do not have permission to add fund.</v-alert
                    >

                    <!-- Display Form if user does have SuperAdmin Role -->
                    <v-form
                      v-else
                      v-model="FormValid"
                      v-on:submit.prevent="validateAddFunds"
                      ref="form"
                    >
                      <v-text-field
                        class="mb-4"
                        type="number"
                        v-model="fundAmount"
                        label="Fund Amount"
                        placeholder="Enter Fund Amount"
                        :rules="amountRules"
                        :min="1"
                        :hint="
                          'Amount ' +
                          (fundAmount ? fundAmount : '0') +
                          ' will be adjusted based on org ovation rate of ' +
                          orgConversionRate +
                          '/unit => ' +
                          calculateOvations +
                          ' Ovations'
                        "
                        persistent-hint
                      ></v-text-field>

                      <!-- <v-autocomplete
                        v-model="fundOrgRecipient"
                        :rules="toRules"
                        :items="orgList"
                        chips
                        color="blue-grey lighten-2"
                        label="Select organization to add funds to"
                        item-text="name"
                        item-value="subdomain"
                      >
                        <template slot="selection" slot-scope="data">
                          {{ data.item.name }}
                        </template>
                        <template slot="item" slot-scope="data">
                          <template v-if="typeof data.item !== 'object'">
                            <v-list-tile-content v-text="data.item"></v-list-tile-content>
                          </template>
                          <template v-else>
                            <v-list-tile-content>
                              <v-list-tile-title>{{data.item.name}}</v-list-tile-title>
                              <v-list-tile-sub-title>{{ isCurrentOrg(data.item.subdomain) ? " (Current Organization)" : "" }} {{data.item.isActive ? "" : "(Status: Disabled)"}}</v-list-tile-sub-title>
                            </v-list-tile-content>
                          </template>
                        </template>
                    </v-autocomplete>-->

                      <v-textarea
                        class="mb-3"
                        v-model="fundingDescription"
                        rows="2"
                        label="Description"
                        placeholder="Enter description"
                        :rules="messageRules"
                      ></v-textarea>

                      <v-btn
                        class="btn-rounded-medium white--text"
                        color="#d13b55"
                        @click.stop="validateAddFunds"
                        :disabled="!FormValid"
                      >
                        Add Fund
                      </v-btn>
                    </v-form>
                  </v-flex>
                </v-card-text>
              </v-card>
            </v-flex>

            <v-flex>
              <v-card color="white" class="rounded">
                <v-card-title class="mb-0">
                  <h4 class="subheading">Remove Fund</h4>
                </v-card-title>
                <v-card-text>
                  <v-alert
                    v-if="!$store.getters.isSuperAdmin"
                    :value="true"
                    type="error"
                    class="mb-3"
                    >Sorry! You do not have permission to remove fund.</v-alert
                  >
                  <v-form
                    v-else
                    v-model="RemoveFormValid"
                    v-on:submit.prevent="validateRemoveFunds"
                    ref="removeForm"
                  >
                    <v-text-field
                      class="mb-4"
                      type="number"
                      v-model="removeFundAmount"
                      label="Fund Amount to Remove"
                      placeholder="Enter Fund Amount to Remove"
                      :rules="removeAmountRules"
                      :min="1"
                      :max="this.$store.state.userSelf.currentOrg.root"
                      hint="Entered amount will be removed from current org Ovations balance"
                      persistent-hint
                    ></v-text-field>

                    <v-textarea
                      class="mb-3"
                      v-model="removeDescription"
                      rows="2"
                      label="Description"
                      placeholder="Enter description"
                      :rules="messageRules"
                    ></v-textarea>

                    <v-btn
                      class="btn-rounded-medium white--text"
                      color="#d13b55"
                      @click.stop="validateRemoveFunds"
                      :disabled="!RemoveFormValid"
                    >
                      Remove Fund
                    </v-btn>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-flex>
        </v-flex>
        <!-- <v-flex mt-3 v-if="$store.getters.isSuperAdmin && $store.getters.isCurrentOrgSet">
            <v-card>
              <v-card-title class="mb-0">
                <h3 class="headline">Fund Transactions: {{$store.getters.getCurrentOrgName}}</h3>
              </v-card-title>
              <v-card-text>
                <v-list dense two-line>
                  <v-divider></v-divider>
                  <div class="pa-2" v-if="loadingFlag">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  </div>
                  <div v-else>
                    <div v-if="orgTransList.length < 1" class="pa-2">
                      <span>No data to display</span>
                    </div>
                    <div v-else v-for="(orgTran,index) in orgTransList" :key="index">
                      <v-list-tile>
                        <v-list-tile-avatar>
                          <v-icon size="40">mdi-currency-usd</v-icon>
                        </v-list-tile-avatar>

                        <v-list-tile-content>
                          <v-list-tile-title>
                            <span class="font-weight-bold">{{orgTran.actualAmount}}</span>
                            <span>&nbsp;&#8594;&nbsp;</span>
                            <span class="font-weight-bold red-text">{{orgTran.amount}}</span>
                          </v-list-tile-title>
                          <v-list-tile-sub-title>On: {{orgTran.date | moment("dddd, MMMM DD, YYYY, h:mm a")}}, By: {{orgTran.depositByName}}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action>
                          <span class="font-italic caption">{{orgTran.description}}</span>
                        </v-list-tile-action>
                      </v-list-tile>
                      <v-divider></v-divider>
                    </div>
                  </div>
                </v-list>
              </v-card-text>
            </v-card>
          </v-flex> -->
      </v-layout>
    </v-flex>

    <v-flex xs12 md3 px-3 mt-3>
      <v-layout column wrap mt-4>
        <BalanceColumn></BalanceColumn>
      </v-layout>
    </v-flex>

    <v-dialog
      v-model="confirmAddFundsDialog"
      overlay
      persistent
      max-width="450"
    >
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title
          >Add Fund to Organization</v-card-title
        >
        <v-card-text>
          <div>
            Are you sure to add
            <span class="font-weight-bold"> {{ calculateOvations }} </span>
            Ovations as <span class="red-text">'Distribute Ovations'</span> to
            the
            <span class="font-weight-bold">{{
              $store.getters.getCurrentOrgName
            }}</span>
            Organization?
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            class="btn-rounded-medium"
            color="secondary"
            outline
            @click="confirmAddFundsDialog = false"
            >Cancel</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            class="btn-rounded-medium"
            color="#d13b55"
            outline
            @click="
              confirmAddFundsDialog = false;
              addFunds();
            "
          >
            <span>Add Fund</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="confirmRemoveFundsDialog"
      overlay
      persistent
      max-width="450"
    >
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title
          >Remove Fund from Organization</v-card-title
        >
        <v-card-text>
          <div>
            Are you sure to remove
            <span class="font-weight-bold"> {{ removeFundAmount }}</span>
            Ovations from <span class="red-text">'Distribute Ovations'</span> of
            the
            <span class="font-weight-bold">{{
              $store.getters.getCurrentOrgName
            }}</span>
            Organization?
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            class="btn-rounded-medium"
            color="secondary"
            outline
            @click="confirmRemoveFundsDialog = false"
            >Cancel</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            class="btn-rounded-medium"
            color="#d13b55"
            outline
            @click="
              confirmRemoveFundsDialog = false;
              removeFunds();
            "
          >
            <span>Remove Fund</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import axios from "axios";
import validationRules from "@/js/validationRules.js";
import BalanceColumn from "@/components/BalanceColumn";

export default {
  name: "AddFunds",
  components: {
    BalanceColumn,
  },
  data() {
    return {
      fundOrgRecipient: null,
      fundAmount: null,
      removeFundAmount: null,
      orgList: [],
      orgTransList: [],
      fundingDescription: "",
      removeDescription: "",
      confirmAddFundsDialog: false,
      confirmRemoveFundsDialog: false,
      FormValid: true,
      RemoveFormValid: true,
      amountRules: validationRules.integerRules,
      removeAmountRules: [
        (v) => !!v || "Required",
        (v) => /^[0-9]+$/.test(v) || "Must be a number",
        (v) =>
          Number(v) <= Number(this.$store.state.userSelf.currentOrg.root) ||
          "Ovations amount should be less or equal to : " +
            this.$store.state.userSelf.currentOrg.root,
      ],
      toRules: validationRules.requiredRules,
      messageRules: validationRules.addressRules,
      loadingFlag: true,
    };
  },
  computed: {
    orgConversionRate: function () {
      return ((this.$store.state.userSelf.currentOrg || {}).org || {})
        .conversionRate;
    },
    calculateOvations: function () {
      return (
        parseInt(this.fundAmount ? this.fundAmount : 0) /
        parseFloat(this.orgConversionRate)
      );
    },
  },
  methods: {
    isCurrentOrg: function (subdomain) {
      return (
        subdomain ==
        ((this.$store.state.userSelf.currentOrg || {}).org || {}).subdomain
      );
    },
    validateAddFunds() {
      if (this.fundAmount <= 0) {
        this.$store.commit("replaceSnackbar", {
          message: "Fund should be a valid amount",
          messageType: "warning",
        });
        return;
      }
      this.confirmAddFundsDialog = true;
    },
    validateRemoveFunds() {
      if (this.removeFundAmount <= 0) {
        this.$store.commit("replaceSnackbar", {
          message: "Remove Fund should be a valid amount",
          messageType: "warning",
        });
        return;
      }
      this.confirmRemoveFundsDialog = true;
    },
    addFunds() {
      this.fundOrgRecipient =
        this.$store.state.userSelf.currentOrg.org.subdomain;

      // Disable form submission while async call takes place
      this.FormValid = false;

      // Display Message
      this.$store.commit("replaceSnackbar", {
        message: "Adding funds...",
        messageType: "warning",
      });

      const params = {
        subdomain: this.fundOrgRecipient,
        channel: "root",
        amount: this.fundAmount,
        unit: "USD",
        description: this.fundingDescription,
      };

      axios
        .post("/api/fund/creditorg", params, this.$store.state.axiosConfig)
        .then((response) => {
          // Allow form submission and reset form
          this.FormValid = true;
          this.$refs.form.reset();

          // form reset above currently wipes out the data, but this appears to currently be a bug, so wiping manually as well to future proof
          // https://github.com/vuetifyjs/vuetify/issues/3316
          this.fundAmount = null;
          this.fundOrgRecipient = null;
          this.fundingDescription = "";

          // Commit returned/received user info to global
          this.$store.commit("setUserSelf", response.data.self);

          // Refresh previous transactions
          //this.loadTrans();

          // Display Success message
          this.$store.commit("replaceSnackbar", {
            message: "Funds has been added to the selected organization",
          });
        })
        .catch((e) => {
          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          // Re-enable form for user to try again
          this.FormValid = true;

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Error. Funds were NOT added.<br>Response: " +
              e.response.data.message,
            messageType: "error",
          });
        });
    },
    removeFunds() {
      // Disable form submission while async call takes place
      this.RemoveFormValid = false;

      // Display Message
      this.$store.commit("replaceSnackbar", {
        message: "Removing funds...",
        messageType: "warning",
      });

      const params = {
        subdomain: this.$store.state.userSelf.currentOrg.org.subdomain,
        channel: "root",
        amount: this.removeFundAmount,
        unit: "USD",
        description: this.removeDescription,
      };

      axios
        .post("/api/fund/debitorg", params, this.$store.state.axiosConfig)
        .then((response) => {
          // Allow form submission and reset form
          this.RemoveFormValid = true;
          this.$refs.removeForm.reset();

          // form reset above currently wipes out the data, but this appears to currently be a bug, so wiping manually as well to future proof
          // https://github.com/vuetifyjs/vuetify/issues/3316
          this.removeFundAmount = null;
          this.removeDescription = "";

          // Commit returned/received user info to global
          this.$store.commit("setUserSelf", response.data.self);

          // Display Success message
          this.$store.commit("replaceSnackbar", {
            message: "Funds has been removed from the current organization",
          });
        })
        .catch((e) => {
          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          // Re-enable form for user to try again
          this.RemoveFormValid = true;

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Error. Funds were NOT removed.<br>Response: " +
              e.response.data.message,
            messageType: "error",
          });
        });
    },
    loadTrans: function () {
      if (
        this.$store.getters.isSuperAdmin &&
        this.$store.getters.isCurrentOrgSet
      ) {
        this.loadingFlag = true;
        // Get the org credit transactions
        axios
          .get("/api/fund/org/transactions", this.$store.state.axiosConfig)
          .then((response) => {
            this.orgTransList = response.data;
            this.loadingFlag = false;
          })
          .catch((e) => {
            // check/ handle 401 (Unauthorized) error
            this.$store.dispatch("error401Response", e);

            // Display Error Message
            this.$store.commit("replaceSnackbar", {
              message:
                "Error. Could not retrieved list of Credit Transactions for the current Org.<br>Response: " +
                e.response.data.message +
                "<br>Error #KNI837",
              messageType: "error",
            });

            this.loadingFlag = false;
          });
      }
    },
  },
  beforeMount() {
    //this.loadTrans();
    // if the user has SuperAdmin role
    // if (this.$store.getters.isSuperAdmin) {
    // Get the list of all orgs
    /* axios
        .get("/api/org/all", this.$store.state.axiosConfig)
        .then(response => {
          // populate the selection box with the list members
          this.orgList = response.data.orgList;
        })
        .catch(e => {
          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Error. Could not retrieved List of All Organizations.<br>Response: " +
              e.response.data.message +
              "<br>Error #KNI837",
            messageType: "error"
          });
        }); */
    // }
  },
};
</script>
